import {TranslatableRental} from "./locations";
import { apt2Photos, mainPhotoApt2} from "./photo";
import {apt2FR} from "./descriptions/fr/apt2";
import {apt2EN} from "./descriptions/en/apt2";


export const apt2: TranslatableRental = {
  roomId: "501221",
  slugs: {
    fr: "appartement-deux-chambres-vue-jardin-avec-terrasse-spa-privatif",
    en: "Two-bedroom-apartment-with-garden-view"
  },
  name: {
    fr: "Appartement deux chambres avec vue sur jardin et spa privatif",
    en: "Two-bedroom apartment with garden view, terrace and private spa",
  },
  description: {
    fr: apt2FR,
    en: apt2EN
  },
  lodgifyId: "435084",
  area: 77,
  capacity: 4,
  numberOfBeds: 2,
  numberOfBedrooms: 2,
  numberOfBathrooms: 1,
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "coffee-machine",
    "fridge",
    "heater",
    "kitchen-storage",
    "swimming",
    "toilet",
    "shower",
    "wheelchair-way",
    "parking",
    "dishwasher",
    "private-spa",
    "microwave",
    "no-smoking",
    "iron",
    "kettle",
    "hair-dryer",
    "household-linen",
    "toaster"
  ],
  mainImage: mainPhotoApt2,
  assets: apt2Photos
};
